/**
 * Detects if Global Privacy Control (GPC) is enabled in the user's browser
 *
 * GPC is a proposed web standard that allows users to signal their privacy preferences
 * to websites. When enabled, it indicates the user does not consent to the sale or sharing
 * of their personal information.
 *
 * @see https://globalprivacycontrol.org/
 * @returns true if GPC is enabled, false otherwise
 */
export function detectGlobalPrivacyControl(): boolean {
  // GPC is only available in browser context
  if (typeof window === 'undefined' || typeof navigator === 'undefined') {
    return false;
  }

  // Check for navigator.globalPrivacyControl
  // TypeScript doesn't have this in the Navigator type yet, so we need to cast
  const nav = navigator as Navigator & { globalPrivacyControl?: boolean };

  // Return true only if explicitly set to true
  return nav.globalPrivacyControl === true;
}
